// import React, { useMemo, useCallback } from "react";
// import {
//   assignColorsToColumn,
//   formatValue,
//   getSortedValuesForColumn,
// } from "./tableUtils";
// import pxToRem from "../../styleUtils";

// const KeyCompetitorTableComponent = React.memo(
//   ({ clientName, companies, columnTypes, competitors }) => {
//     // Filter out columns that should not be displayed (e.g., IQ_TOTAL_CAP)
//     const filteredColumnTypes = useMemo(
//       () => columnTypes.filter((type) => type !== "IQ_TOTAL_CAP"),
//       [columnTypes]
//     );

//     // Function to get the display name for a column type
//     const getColumnHeader = useCallback((type) => {
//       const headerMap = {
//         IQ_TOTAL_REV: "Total Revenue",
//         IQ_GP: "Gross Profit",
//         IQ_EBITDA: "EBITDA",
//         IQ_EBIT: "EBIT",
//         IQ_NI: "Net Income",
//         IQ_BASIC_EPS_INCL: "EPS",
//         IQ_TOTAL_ASSETS: "Total Assets",
//       };
//       return headerMap[type] || type.replace("IQ_", "").replace(/_/g, " ");
//     }, []);

//     // Memoize the sorted values and colors for each column since these wont change without a refesh
//     const columnData = useMemo(() => {
//       return filteredColumnTypes.map((type) => {
//         const sortedValues = getSortedValuesForColumn(type, competitors);
//         const coloredData = assignColorsToColumn(
//           type,
//           competitors,
//           sortedValues
//         );
//         return { type, sortedValues, coloredData };
//       });
//     }, [filteredColumnTypes, competitors]);

//     return (
//       <div className="new_competitiors_table_block">
//         <div className="table_responsive">
//           <table className="table table-stried table-bordered new_comp_table">
//             <thead>
//               <tr>
//                 <th
//                   className="new_comp_th text-left"
//                   style={{ maxWidth: pxToRem(300), minWidth: pxToRem(300) }}
//                 >
//                   Company Name
//                 </th>
//                 {/* Dynamically render headers based on filteredColumnTypes */}
//                 {filteredColumnTypes.map((type, index) => (
//                   <th key={type} className="new_comp_th">
//                     {getColumnHeader(type)}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {competitors.map((competitor) => (
//                 <tr className="new_comp_tr" key={competitor._id}>
//                   <td className="new_comp_td">
//                     <div className="company_name">
//                       {companies[competitor._id]}
//                     </div>
//                   </td>
//                   {columnData.map(({ type, coloredData }, index) => {
//                     // const competitorData = coloredData.find((entry) => entry.id === competitor._id);
//                     const competitorData = coloredData?.find(
//                       (entry) => entry.id === competitor._id
//                     );
//                     const value = competitorData ? competitorData.value : "N/A";
//                     const color = competitorData ? competitorData.color : "";
//                     const formattedValue = formatValue(value, type);

//                     return (
//                       <td key={type} className={`new_comp_td ${color}`}>
//                         {formattedValue}
//                       </td>
//                     );
//                   })}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className="row">
//           <div className="col-md-8"> &nbsp; </div>
//           <div className="col-md-4">
//             <div className="img-right">
//               <div className="min_max_block">
//                 <p className="max">Max</p>
//                 <p className="min">Min</p>
//               </div>
//               <div className="img_min_block">
//                 <img
//                   src="/img/Key-Competitors-legend1.png"
//                   alt="icons"
//                   className="compnay_image_subnav"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// );

// export default KeyCompetitorTableComponent;

import React, { useMemo, useCallback } from "react";
import {
  assignColorsToColumn,
  formatValue,
  getSortedValuesForColumn,
} from "./tableUtils";
import pxToRem from "../../styleUtils";

const KeyCompetitorTableComponent = React.memo(
  ({ clientName, companies, columnTypes, competitors }) => {
    // ⭐ Convert competitor.data into an object like:
    // { IQ_TOTAL_REV: 1200, IQ_GP: 500, ... }
    const normalizedCompetitors = useMemo(() => {
      return competitors.map((c) => ({
        ...c,
        metricMap: c.data?.reduce((acc, item) => {
          acc[item.type] = item.value;
          return acc;
        }, {}),
      }));
    }, [competitors]);

    // Remove IQ_TOTAL_CAP
    const filteredColumnTypes = useMemo(
      () => columnTypes.filter((type) => type !== "IQ_TOTAL_CAP"),
      [columnTypes]
    );

    const getColumnHeader = useCallback((type) => {
      const headerMap = {
        IQ_TOTAL_CAP: "Total Cap",
        IQ_TOTAL_REV: "Total Revenue",
        IQ_GP: "Gross Profit",
        IQ_EBITDA: "EBITDA",
        IQ_EBIT: "EBIT",
        IQ_NI: "Net Income",
        IQ_BASIC_EPS_INCL: "EPS",
        IQ_TOTAL_ASSETS: "Total Assets",
      };
      return headerMap[type] || type.replace("IQ_", "").replace(/_/g, " ");
    }, []);

    // ⭐ Now utilities receive correct data because metricMap has direct values
    const columnData = useMemo(() => {
      return filteredColumnTypes.map((type) => {
        const sortedValues = getSortedValuesForColumn(
          type,
          normalizedCompetitors,
          "metricMap"
        );
        const coloredData = assignColorsToColumn(
          type,
          normalizedCompetitors,
          sortedValues,
          "metricMap"
        );
        return { type, sortedValues, coloredData };
      });
    }, [filteredColumnTypes, normalizedCompetitors]);

    return (
      <div className="new_competitiors_table_block">
        <div className="table_responsive">
          <table className="table table-stried table-bordered new_comp_table">
            <thead>
              <tr>
                <th
                  className="new_comp_th text-left"
                  style={{
                    maxWidth: pxToRem(300),
                    minWidth: pxToRem(300),
                  }}
                >
                  Company Name
                </th>

                {filteredColumnTypes.map((type) => (
                  <th key={type} className="new_comp_th">
                    {getColumnHeader(type)}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {normalizedCompetitors.map((competitor) => (
                <tr className="new_comp_tr" key={competitor._id}>
                  <td className="new_comp_td">
                    <div className="company_name">
                      {companies[competitor._id]}
                    </div>
                  </td>

                  {columnData.map(({ type, coloredData }) => {
                    const competitorData = coloredData?.find(
                      (entry) => entry.id === competitor._id
                    );

                    const value = competitorData?.value ?? "N/A";
                    const color = competitorData?.color ?? "";
                    const formattedValue = formatValue(value, type);

                    return (
                      <td key={type} className={`new_comp_td ${color}`}>
                        {formattedValue}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="row">
          <div className="col-md-8">&nbsp;</div>
          <div className="col-md-4">
            <div className="img-right">
              <div className="min_max_block">
                <p className="max">Max</p>
                <p className="min">Min</p>
              </div>
              <div className="img_min_block">
                <img
                  src="/img/Key-Competitors-legend1.png"
                  alt="icons"
                  className="compnay_image_subnav"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default KeyCompetitorTableComponent;
